import { initFacialExpression, setFacialExpression } from '@modules/facialExpression';
import { useDispatch } from '@stores';
import { IStoreFacialExpression } from '@types';
import { useCallback } from 'react';

const useFacialExpressionActions = () => {
  const dispatch = useDispatch();

  const onInitFacialExpression = useCallback(() => {
    dispatch(initFacialExpression());
  }, [dispatch]);

  const onSetFacialExpression = useCallback(
    (payload: IStoreFacialExpression) => {
      dispatch(setFacialExpression(payload));
    },
    [dispatch]
  );

  return { onInitFacialExpression, onSetFacialExpression };
};

export default useFacialExpressionActions;
